import { ComponentType, resolveEditorCapabilities } from '@wix/a11y-adapters';
import { MembersCustomPageManagedByWixAppId } from '../../../../constants';
import { INACCESSIBLE_COMPONENTS, INACCESSIBLE_TPA_COMPONENTS, MembersWidgetAppId, TPA_ALTERNATIVES } from '../constants';
import { CustomMembersPage } from '../types';
export const getAllInaccessibleComponentTypes = () => {
  const baseTypes = Object.values(INACCESSIBLE_COMPONENTS).map(_ref => {
    let {
      componentType
    } = _ref;
    return componentType;
  });
  const tpaTypes = Object.values(INACCESSIBLE_TPA_COMPONENTS).map(_ref2 => {
    let {
      componentType
    } = _ref2;
    return componentType;
  });
  return [...baseTypes, ...tpaTypes];
};
export const getTpaNameById = tpaId => {
  var _INACCESSIBLE_TPA_COM;
  return (_INACCESSIBLE_TPA_COM = INACCESSIBLE_TPA_COMPONENTS[tpaId]) == null ? void 0 : _INACCESSIBLE_TPA_COM.name;
};
export const getTpaAlternative = tpaId => {
  const tpaName = getTpaNameById(tpaId);
  if (!tpaName) {
    return undefined;
  }
  const alternative = TPA_ALTERNATIVES[tpaName];
  return alternative === null ? undefined : alternative;
};
export const isTpaComponent = type => Object.values(INACCESSIBLE_TPA_COMPONENTS).some(tpa => tpa.componentType === type);
export const isInaccessibleTpa = tpaIds => tpaIds.some(id => {
  const tpaName = getTpaNameById(id);
  return tpaName && tpaName in TPA_ALTERNATIVES;
});
export const getInaccessibleMenuComponents = (dsDataExtractor, editorType, breakpointId) => {
  const menuComponents = dsDataExtractor.getComponentIdsByType([INACCESSIBLE_COMPONENTS.Menu.componentType, INACCESSIBLE_COMPONENTS.HorizontalMenu.componentType], breakpointId);
  const inaccessibleMenuComponents = [];
  const {
    usesClassicMenuHierarchy
  } = resolveEditorCapabilities(editorType);
  for (const menuCompId of menuComponents) {
    const componentType = dsDataExtractor.getComponentType(menuCompId);
    let shouldMarkAsInaccessible = false;

    // Studio/OD: MegaMenu direct children; Classic HorizontalMenu: StripColumnsContainer columns (see usesClassicMenuHierarchy).
    if (!usesClassicMenuHierarchy) {
      const children = dsDataExtractor.getDirectComponentChildren(menuCompId);
      const megaMenuItems = children.filter(childId => dsDataExtractor.getComponentType(childId) === ComponentType.MegaMenu);
      shouldMarkAsInaccessible = megaMenuItems.some(megaMenuItemId => {
        const megaMenuChildren = dsDataExtractor.getDirectComponentChildren(megaMenuItemId);
        const hasSubmenu = megaMenuChildren.some(childId => dsDataExtractor.getComponentType(childId) === ComponentType.SubMenu);
        const hasOtherChildren = megaMenuChildren.some(childId => dsDataExtractor.getComponentType(childId) !== ComponentType.SubMenu);
        return !hasSubmenu && hasOtherChildren;
      });
    } else if (componentType === INACCESSIBLE_COMPONENTS.HorizontalMenu.componentType) {
      const children = dsDataExtractor.getDirectComponentChildren(menuCompId);
      const megaMenuItems = children.filter(childId => dsDataExtractor.getComponentType(childId) === ComponentType.MegaMenu);
      shouldMarkAsInaccessible = megaMenuItems.some(megaMenuItemId => {
        const megaMenuChildren = dsDataExtractor.getDirectComponentChildren(megaMenuItemId);
        const stripContainers = megaMenuChildren.filter(childId => dsDataExtractor.getComponentType(childId) === ComponentType.StripColumnsContainer);
        return stripContainers.some(stripContainerId => {
          const stripChildren = dsDataExtractor.getDirectComponentChildren(stripContainerId);
          const columns = stripChildren.filter(childId => dsDataExtractor.getComponentType(childId) === ComponentType.Column);
          return columns.some(columnId => {
            const columnChildren = dsDataExtractor.getDirectComponentChildren(columnId);
            return columnChildren.some(childId => dsDataExtractor.getComponentType(childId) !== ComponentType.SubMenu);
          });
        });
      });
    }
    if (shouldMarkAsInaccessible) {
      inaccessibleMenuComponents.push({
        id: menuCompId,
        type: componentType
      });
    }
  }
  return inaccessibleMenuComponents;
};
export const getInaccessibleMembersComponents = (dsDataExtractor, membersCustomPage, breakpointId) => {
  if (membersCustomPage === MembersCustomPageManagedByWixAppId.SignUp || membersCustomPage === MembersCustomPageManagedByWixAppId.SignIn) {
    const inaccessibleMembersComponents = dsDataExtractor.getComponentIdsByType([INACCESSIBLE_COMPONENTS.AppWidget.componentType], breakpointId).map(compId => {
      const controllerType = dsDataExtractor.getComponentControllerType(compId);
      if (controllerType === CustomMembersPage.CustomSignIn || controllerType === CustomMembersPage.RegistrationForm) {
        return {
          id: compId,
          tpaId: membersCustomPage === MembersCustomPageManagedByWixAppId.SignUp ? MembersWidgetAppId.SignUp : MembersWidgetAppId.SignIn,
          type: INACCESSIBLE_COMPONENTS.AppWidget.componentType
        };
      }
      return null;
    }).filter(comp => comp !== null && (comp.tpaId === MembersWidgetAppId.SignUp || comp.tpaId === MembersWidgetAppId.SignIn));
    return inaccessibleMembersComponents;
  }
  return [];
};
//# sourceMappingURL=inaccessible-components-helpers.js.map